import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

/** Ported from gpp-website blocking popup logo for matching dimensions. */
export const AKBetsCompliancePopupLogo = ({ className }: PropsType): React.ReactElement => (
    <SvgElement
        className={className}
        xmlns='http://www.w3.org/2000/svg'
        width='152'
        height='32'
        viewBox='0 0 152 32'
        fill='#E8530E'
    >
        <path
            d='M22.2244 27.4849L20.9566 23.987H11.9044L10.6007 27.4849H3.53906L12.7969 4.5151H20.0641L29.3219 27.4849H22.2244ZM16.4644 11.5767L13.9269 18.4687H18.9661L16.4624 11.5767H16.4644Z'
            fill='#E8530E'
        ></path>
        <path
            d='M46.2224 27.4849L40.9077 19.5648L37.5136 23.6456V27.4849H30.9311V4.5151H37.5136V14.4218L45.881 4.5151H53.3559L45.1962 14.3898L54.1785 27.4869H46.2244L46.2224 27.4849Z'
            fill='#E8530E'
        ></path>
        <path
            d='M78.5179 15.7594C80.9177 15.8273 83.3853 17.2688 83.3853 21.0042C83.3853 24.7397 80.4705 27.4849 75.603 27.4849H63.1228V4.5151H75.603C79.8895 4.5151 82.7005 6.94884 82.7005 10.6524C82.7005 14.0804 80.2329 15.5558 78.5179 15.6237V15.7614V15.7594ZM69.7073 13.8747H73.7881C75.2616 13.8747 76.2558 13.0182 76.2558 11.7145C76.2558 10.4108 75.2616 9.62216 73.89 9.62216H69.7073V13.8747ZM74.1295 22.3778C75.7068 22.3778 76.6332 21.4515 76.6332 20.0819C76.6332 18.7123 75.6389 17.9556 74.1994 17.9556H69.7073V22.3778H74.1295Z'
            fill='#E8530E'
        ></path>
        <path
            d='M104.197 27.4849H85.9229V4.5151H104.059V10.0694H92.5054V13.4634H103.133V18.5026H92.5054V21.9306H104.197V27.4849Z'
            fill='#E8530E'
        ></path>
        <path
            d='M119.967 10.1712V27.4849H113.351V10.1712H106.152V4.5151H127.169V10.1712H119.967Z'
            fill='#E8530E'
        ></path>
        <path
            d='M148.252 10.6863L141.807 11.99C141.362 9.79586 139.681 9.11106 138.345 9.11106C136.906 9.11106 135.911 9.83179 135.911 10.9618C135.911 11.6127 136.151 12.1957 137.249 12.4352L141.911 13.5333C146.128 14.5955 148.459 16.6539 148.459 20.3554C148.459 25.738 143.454 28 138.689 28C133.1 28 128.848 25.2907 128.197 20.9024L134.917 19.6346C135.466 21.7949 136.872 22.6853 138.826 22.6853C140.404 22.6853 141.536 22.0344 141.536 20.8345C141.536 20.1497 141.226 19.6007 139.958 19.2912L135.193 18.1592C131.353 17.2688 128.884 15.3142 128.884 11.5089C128.884 6.67532 132.965 4 138.347 4C143.73 4 147.433 6.3998 148.256 10.6863H148.252Z'
            fill='#E8530E'
        ></path>
    </SvgElement>
);
